import {
  EntitlementsProject,
  TOOL_IDS,
  PRODUCT_IDS,
} from '@adsk/alloy-provider';

import { CommonReferencePickerPlugin } from '../types/ReferencePickerPlugin';

/**
 * Checks whether it's Photos plugin and user has no Build access in current project.
 * @param plugin
 * @param currentProject
 * @return {boolean}
 */
export const isPhotosPluginAndUserHasNoBuildAccess = ({
  plugin,
  currentProject,
}: {
  plugin: CommonReferencePickerPlugin;
  currentProject?: EntitlementsProject;
}) => {
  return (
    plugin?.toolId === TOOL_IDS.PHOTOS &&
    !currentProject?.products.some(
      (product) => product.key === PRODUCT_IDS.BUILD,
    )
  );
};
